import { render, staticRenderFns } from "./BlockTopMessageCommon.vue?vue&type=template&id=089ee381&"
import script from "./BlockTopMessageCommon.vue?vue&type=script&lang=ts&"
export * from "./BlockTopMessageCommon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports